module.exports = "pegasus/assets/blocks/column-lp16-themelp1.png";